import Color from "color";

export default class ChartColors
{

    // https://www.figma.com/file/rkEtOfusTw9ruvBWA2jGdK/01---ASAP-'25?node-id=4%3A32740
    public static readonly COLORS = [
		'#009FE3', '#92C329', '#D8DE31', '#D1A022', '#2DC3A8', '#CF7736',
		'#D92F80', '#9D2FD0', '#6633BB', '#2B4088', '#176CA1', '#397C40',
		'#A62320', '#CA4B40', '#24CBD6', '#239208', '#27B16F', '#C939A9',
		'#DB121E', '#B7CA40',
	];

	// Neutral color of the total ("Celkový výsledek"), used when the total has no color of
	// its own. On dark themes it is a light cool grey: kept apart from the saturated
	// palette and from #909090, the fallback of series without a color.
	public static get COLOR_TOTAL(): string {
		return ChartColors.isDarkTheme() ? '#C8D2DC' : '#3A3A3A';
	}

	public static isDarkTheme(): boolean {
		if (typeof document === 'undefined' || !document.body) {
			return false;
		}

		return getComputedStyle(document.body)
            .getPropertyValue('color-scheme')
            .includes('dark');
	}

	public static resolveTotalColor(
        colorTotal?: string | null,
        seriesColor?: string | string[] | null,
    ): string {
		if (colorTotal) {
			return ChartColors.adaptNeutralInk(colorTotal);
		}
		if (typeof seriesColor === 'string' && seriesColor !== '') {
			return ChartColors.adaptNeutralInk(seriesColor);
		}
		return ChartColors.COLOR_TOTAL;
	}

	/**
	 * Totals are commonly configured as black or a dark grey — meant as "neutral ink" for a
	 * light background and invisible on a dark one. Only such achromatic dark colors are
	 * swapped for the theme neutral; a chromatic color is a deliberate choice and is kept.
	 */
	private static adaptNeutralInk(color: string): string {
		if (!ChartColors.isDarkTheme()) {
			return color;
		}

		try {
			const parsed = Color(color);
			if (parsed.isDark() && parsed.hsl().saturationl() < 15) {
				return ChartColors.COLOR_TOTAL;
			}
		} catch (e) {
			// not a parseable color (e.g. a gradient object serialized as string) — leave it be
		}

		return color;
	}

	public static getColorByIndex(index): string {
		return ChartColors.COLORS[index % ChartColors.COLORS.length];
	}


	public static pickColor(color: string | string[] | null | undefined, index: number, defaultColor: string = null): string {
		if (typeof color === 'string') {
			return color;
		}
		if (defaultColor) {
			return defaultColor;
		}
		return color?.[index % color.length] ?? null;
	}
}
